<template>
  <VAutocompleteWithValidation
    v-model="selected"
    :label="label"
    outlined
    dense
    background-color="white"
    :items="items"
    :clearable="true"
  />
</template>

<script>
import VAutocompleteWithValidation from './validators/VAutocompleteWithValidation.vue'

export default {
  name: 'YesNoAutocomplete',
  components: { VAutocompleteWithValidation },
  props: {
    value: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    selected: null,
    items: ['Ano', 'Ne'],
  }),
  watch: {
    selected: function () {
      if (this.selected === 'Ano') {
        this.$emit('input', true)
      } else if (this.selected === 'Ne') {
        this.$emit('input', false)
      } else {
        this.$emit('input', null)
      }
    },
  },
  created() {
    if (this.value == null) {
      this.selected = null
    } else if (this.value) {
      this.selected = 'Ano'
    } else {
      this.selected = 'Ne'
    }
  },
}
</script>
